/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppErrorDto } from './AppErrorDto';
import {
    AppErrorDtoFromJSON,
    AppErrorDtoFromJSONTyped,
    AppErrorDtoToJSON,
} from './AppErrorDto';

/**
 * 
 * @export
 * @interface DriverPermissionCheckResultDto
 */
export interface DriverPermissionCheckResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof DriverPermissionCheckResultDto
     */
    granted: boolean;
    /**
     * 
     * @type {Array<AppErrorDto>}
     * @memberof DriverPermissionCheckResultDto
     */
    errors: Array<AppErrorDto>;
    /**
     * 
     * @type {number}
     * @memberof DriverPermissionCheckResultDto
     */
    fallbackPaymentProfileId?: number;
}

/**
 * Check if a given object implements the DriverPermissionCheckResultDto interface.
 */
export function instanceOfDriverPermissionCheckResultDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "granted" in value;
    isInstance = isInstance && "errors" in value;

    return isInstance;
}

export function DriverPermissionCheckResultDtoFromJSON(json: any): DriverPermissionCheckResultDto {
    return DriverPermissionCheckResultDtoFromJSONTyped(json, false);
}

export function DriverPermissionCheckResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriverPermissionCheckResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'granted': json['granted'],
        'errors': ((json['errors'] as Array<any>).map(AppErrorDtoFromJSON)),
        'fallbackPaymentProfileId': !exists(json, 'fallbackPaymentProfileId') ? undefined : json['fallbackPaymentProfileId'],
    };
}

export function DriverPermissionCheckResultDtoToJSON(value?: DriverPermissionCheckResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'granted': value.granted,
        'errors': ((value.errors as Array<any>).map(AppErrorDtoToJSON)),
        'fallbackPaymentProfileId': value.fallbackPaymentProfileId,
    };
}

